import { render, staticRenderFns } from "./transit-page.vue?vue&type=template&id=21c54e90&scoped=true&"
import script from "./transit-page.vue?vue&type=script&lang=js&"
export * from "./transit-page.vue?vue&type=script&lang=js&"
import style0 from "./transit-page.vue?vue&type=style&index=0&id=21c54e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c54e90",
  null
  
)

export default component.exports